if (!customElements.get('plyr-video')) {
  class PlyrVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');

      this.player = new Plyr(this.video, {
        controls: ['play', 'mute', 'progress', 'play-large', 'fullscreen'],
      });
    }
  }

  customElements.define('plyr-video', PlyrVideo);
}